import { useEffect } from 'react';

const SEO = ({
  title,
  description,
  path = '',
  type = 'website',
}) => {
  const siteUrl = 'https://cliktechnologies.com';
  const fullUrl = `${siteUrl}${path}`;
  const siteName = 'Clik Technologies';
  const fullTitle = title
    ? `${title} | ${siteName}`
    : `${siteName} | AI Products, Full-Stack Platforms & Engineering Teams`;

  useEffect(() => {
    document.title = fullTitle;

    const setMeta = (attr, key, content) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    if (description) setMeta('name', 'description', description);
    setMeta('property', 'og:title', fullTitle);
    setMeta('property', 'og:url', fullUrl);
    setMeta('property', 'og:type', type);
    if (description) setMeta('property', 'og:description', description);
    setMeta('name', 'twitter:title', fullTitle);
    if (description) setMeta('name', 'twitter:description', description);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', fullUrl);
  }, [fullTitle, description, fullUrl, type]);

  return null;
};

export default SEO;
